module.exports = __webpack_public_path__ + "img/charged_logo.d57d4cfb.png";